import { motion } from 'framer-motion'

import Img from './assets/sprites/Frame 6.webp'
import { useScrollingOrnament } from './useScrollingOrnament'

const SLIDES_COUNT = 11
const VIEWPORT_HEIGHT = 68
const OFFSET = 0

export const Ornament1 = () => {
  const { ref, slideNum } = useScrollingOrnament(
    SLIDES_COUNT,
    VIEWPORT_HEIGHT,
    OFFSET
  )

  return (
    <div ref={ref}>
      <svg
        viewBox={`0 0 758 ${Math.round(VIEWPORT_HEIGHT) - 3}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.image href={Img} width="759" x="0" y={slideNum} />
      </svg>
    </div>
  )
}
